// extracted by mini-css-extract-plugin
export default {"diagonalBackground":"Homepage_diagonalBackground__VKRxf"};